import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { getConfig } from 'functions/getConfig';
import { useLanguageVersions } from 'hooks/useConfig';
import { useLoadFreecodeTicketInspect } from 'hooks/useFreecode';
import Path from 'routes/Path';
import { FreecodeLoading } from 'components/FreecodeLoading/FreecodeLoading';
import FreecodePage from 'components/FreecodePage/FreecodePage';
import { useFreecodeContext } from 'hooks/useContext';
import FreecodeEditorComponents from 'components/FreecodePage/FreecodeEditorComponents';
import PageUnderConstruction from 'components/FreecodePage/PageUnderConstruction';

export default function FreecodeTestInspect() {
  const { inputId } = useParams();

  const [loadingDone, setLoadingDone] = useState(false);
  const [loadingError, setLoadingError] = useState(undefined);
  const [headerLinks, setHeaderLinks] = useState([]);

  const { setTest, setTestImpl, setLanguageData, setLanguage, setCode, setInput } = useFreecodeContext();
  const ticketRef = useRef(undefined);

  const [languageVersions /** ignore next */, , languageVersionsError] = useLanguageVersions();
  const [freecodeResponse /** ignore next */, , freecodeError] = useLoadFreecodeTicketInspect(inputId);

  useEffect(() => {
    if (!languageVersions || !freecodeResponse) return;
    // When loading is done destructure the data
    try {
      let { test, testImpl, ticket, input } = freecodeResponse;
      setInput(input);
      setTest(test);
      setTestImpl(testImpl);
      setLanguageData({ [input.language]: languageVersions[testImpl.executionVersion][input.language] });
      setLanguage(input.language);
      setCode(input.code);
      ticketRef.value = ticket;
      setHeaderLinks([
        { link: `${getConfig().REDIRECTION_URL}/report/${ticket._id}/`, label: 'Report' },
        {
          link: `${getConfig().REDIRECTION_ROOT_URL}/freecode-show-code/${ticket._id}/${input._id}`,
          label: 'Old Editor',
        },
      ]);
      setLoadingDone(true);
    } catch (error) {
      setLoadingError('Could not unpack freecode data');
    }
  }, [languageVersions, freecodeResponse, setLanguageData, setLanguage, setCode, setInput, setTest, setTestImpl]);

  return (
    <FreecodePage headerLinks={headerLinks}>
      <FreecodeLoading
        signInRequired
        loading={!loadingDone}
        errors={[languageVersionsError, freecodeError, loadingError]}
        errorLinkText="Go to home page"
        errorLink={Path.landingPage}
      />
      <PageUnderConstruction />
      {loadingDone && <FreecodeEditorComponents />}
    </FreecodePage>
  );
}
